<template>
  <div>
    <Loading v-if="isLoadingPage"></Loading>
    <template v-else>
      <div class="home">
        <div class="home__container" v-if="step === 1">
          <div class="home__container--item" @click="handleStep(2)">
            <div class="home__container--item--manual">
              <img src="~ThemePath/images/home/img_manual.png" alt="" />
            </div>
            <span>{{ getTranslatedText("manual entry") }}</span>
          </div>
          <div class="home__container--item" @click="$router.push({ name: 'TicketValidation' })">
            <div class="home__container--item--ticket">
              <img src="~ThemePath/images/home/img_validation.png" alt="" />
            </div>
            <span>{{ getTranslatedText("ticket validation") }}</span>
          </div>
        </div>
          <div class="home__loto" v-if="step === 2">
            <div class="home__loto--item" v-for="(item, id) in dataOdds" :key="id">
              <div @click="item.enabled ? $router.push({name: item.nameRouter}) : $event.preventDefault()" class="home__loto--item--loto">
                <img :src="item?.image" :alt="item?.name" />
              </div>
              <span>{{ item?.name ? item?.name : getTranslatedText("loto hotpicks") }}</span>
              <ButtonCommon :isNoHover="true" text="view loto odds" @action-button="handleShowLotoOdds(id + 3, item?.slug, item?.name)" type="" />
            </div>
          </div>
      </div>
      <div class="loto_odds" :class="{ lotovert: step === 5 }" v-if="step >= 3">
        <div class="loto_odds__title">
          <h2>{{ getTranslatedText(dataLotoOdds.title) }}</h2>
        </div>
        <div class="loto_odds__note">
          <span>{{ getTranslatedText(dataLotoOdds.note) }}</span>
        </div>
        <div class="loto_odds__table">
          <div class="loto_odds__table--left">
            <v-table>
              <thead>
                <tr>
                  <th class="text-left">
                    {{ getTranslatedText("Bet Type") }}
                  </th>
                  <th class="text-left">
                    {{ getTranslatedText("Odds (decimal)") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in dataLotoOdds.dataLoto" :key="item.name">
                  <td>{{ getTranslatedText(item.name) }}</td>
                  <td>{{ renderPrice(item.odds) }}</td>
                </tr>
              </tbody>
            </v-table>
          </div>
          <div class="loto_odds__table--right" v-if="dataLotoOdds?.dataBet">
            <v-table>
              <thead>
                <tr>
                  <th class="text-left">
                    {{ getTranslatedText("Bet Type") }}
                  </th>
                  <th class="text-left">
                    {{ getTranslatedText("Odds (decimal)") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="tb-title">
                  <td colspan="2">{{ getTranslatedText("Total Value") }}</td>
                </tr>
                <tr v-for="item in dataLotoOdds.dataBet" :key="item.name">
                  <td>{{ item.totalValue }}</td>
                  <td>{{ renderPrice(item.odds) }}</td>
                </tr>
              </tbody>
            </v-table>
          </div>
        </div>
        <div class="loto_odds__button">
          <ButtonCommon :isNoHover="true" text="Close" type="" @action-button="handleStep(2)" />
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import languageMixins from "@/mixins/language/language-mixins";
import configGameMinxins from "@/mixins/configGame/configGame-mixins";
import ButtonCommon from "@/components/common/button";
import EventBus from "@/utils/EventBus";
import Loading from "@/components/common/loading";
import GamesService from "@/services/games.service";
import { formatPrice } from "@/utils/utils";

export default {
  mixins: [languageMixins, configGameMinxins],
  components: { ButtonCommon, Loading },
  data() {
    return {
      step: 1,
      dataLotoOdds: {},
      isLoadingPage: false,
      dataGames:''
    };
  },
  computed: {
    dataOdds(){
      const modifiedGames =  this.configGame.map((game) => {
        let linkImage, nameRouter;
        if (game.slug === 'loto-hotpicks') {
          linkImage = require('ThemePath/images/home/img_loto.png');
          nameRouter = 'loto';
        } else if (game.slug === 'loto-vert-hotpicks') {
          linkImage = require('ThemePath/images/home/img_loto_vert.png');
          nameRouter = 'loto vert';
        } else if(game.slug === 'loto-plus-hotpicks'){
          linkImage = require('ThemePath/images/home/img_loto.png');
          nameRouter = 'loto plus';
        } else {
          linkImage = require('ThemePath/images/home/img_loto.png');
          nameRouter = 'loto';
        }
        return {
          ...game,
          image: linkImage,
          nameRouter: nameRouter
        }
      })

      // move loto-plus-hotpicks up 1 position
      const lotoPlusGameIndex = modifiedGames.findIndex(game => game.slug === 'loto-plus-hotpicks');
      if (lotoPlusGameIndex !== -1) {
        const lotoPlusGame = modifiedGames.splice(lotoPlusGameIndex, 1)[0];
        const newPosition = Math.min(lotoPlusGameIndex - 1, modifiedGames.length);
        modifiedGames.splice(newPosition, 0, lotoPlusGame);
      }
      return modifiedGames;
    }
  },
  created(){
    EventBus.$on("reset-steps", () => this.step = 1);
  },
  destroyed(){
    EventBus.$off("reset-steps")
  },
  mounted() {
    document.addEventListener('message', this.handleMessage);
    window.addEventListener('popstate', (e) => {
      this.handlePopState(e)
    });
  },
  beforeDestroy() {
    document.removeEventListener('message', this.handleMessage)
    window.removeEventListener('popstate', this.handlePopState);
  },
  methods: {
    async fetchDataGames() {
      try {
        this.isLoadingPage = true;
        const res = await GamesService.getListGame();
        if (res.status === "success") {
          this.dataGames = res.data;
        } else {
          console.log(res)
        }
        this.isLoadingPage = false;
      } catch (error) {
        console.log(error);
        this.isLoadingPage = false;
      }
    },
    handleMessage(event) {
      const resp = JSON.parse(event.data)
      if (resp.command === 'go-back') {
        if (this.$route.name.toLowerCase() === 'home') {
          if (this.step !== 1) {
            this.step -= 1;
          } else {
            parent.postMessage({ command: 'on-confirm-out-app' }, '*')
          }
        }
      }
    },

    handlePopState(event) {
      if (this.$route.name.toLowerCase() === 'home') {
        if (this.step !== 1) {
          event.preventDefault();
          window.history.pushState(null, "", window.location.href);
          this.step -= 1;
        }
      }
    },
    handleRedirect(nameRouter, event) {
      if(nameRouter === 'loto'){
        this.configGame[0]?.enabled ? this.$router.push({ name: nameRouter }) : event.preventDefault()
      }else if(nameRouter === 'loto vert'){
        this.configGame[1]?.enabled ? this.$router.push({ name: nameRouter }) : event.preventDefault()
      } else if (nameRouter === 'loto plus') {
        this.configGame[2]?.enabled ? this.$router.push({ name: nameRouter }) : event.preventDefault()
      } else{
        this.$router.push({ name: nameRouter })
      }
    },
    handleStep(step) {
      this.step = step;
    },
    async handleShowLotoOdds(step, slugGame, nameGame) {
      if (!this.dataGames) await this.fetchDataGames();
      this.handleStep(step);
      this.dataLotoOdds.title = nameGame;
      const gameLoto = this.dataGames.find(item => item.game?.slug === slugGame);
      this.dataLotoOdds.dataLoto = gameLoto?.markets.map(e => {
        if (e.odds === 0) {
          if (e.market_slug !== 'totalvalue') {
            return {
              name: e.market_name,
              odds: Object.values(e?.config?.outcomes)[0].odds
            };
          }
        } else {
          return { name: e.market_name, odds: e.odds };
        }
      }).filter(e => e !== undefined)
      const dataBet = gameLoto?.markets?.find(item => item.market_slug === 'totalvalue')?.config?.outcomes;
      if (dataBet) {
        this.dataLotoOdds.dataBet = Object.values(dataBet).map(e => ({
          totalValue: e.name,
          odds:e.odds
        }))
      } else {
        this.dataLotoOdds.dataBet = ''
      }

      if (this.step === 3) {
        this.dataLotoOdds.note = "Loto Draws are conducted every Wednesday and Saturday where 6 balls are drawn from a set of 40 balls (numbered 1 to 40)"
      } else if (this.step === 4) {
        this.dataLotoOdds.note = "Loto Plus Draws are conducted every Wednesday and Saturday where 6 balls are drawn from a set of 40 balls (numbered 1 to 40)"
      } else if (this.step === 5) {
        this.dataLotoOdds.note = "Loto Vert Draw is conducted every Friday where 7 balls are drawn from a set of 28 balls (numbered 1 to 28)"
      }
    },
    renderPrice(price) {
      return formatPrice(price);
    },
  },
};
</script>
<style lang="scss">
@import "~ThemePath/scss/home/_index.scss";
</style>
